import { render, staticRenderFns } from "./NewBalanceSheet.vue?vue&type=template&id=2d31b956&scoped=true"
import script from "./NewBalanceSheet.vue?vue&type=script&lang=js"
export * from "./NewBalanceSheet.vue?vue&type=script&lang=js"
import style0 from "./NewBalanceSheet.vue?vue&type=style&index=0&id=2d31b956&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d31b956",
  null
  
)

export default component.exports